import { NavLink } from "react-router-dom";

export default function Footer({ t }) {
  return (
    <footer className="bg-custom text-black">
      <div
        className="mx-auto px-4"
        style={{ maxWidth: "1100px" }}
      >

        <div className="d-flex justify-content-end pt-2">
          <NavLink
            to="https://www.instagram.com/flutejuliehuguet"
            target="_blank"
            className="text-black text-decoration-none me-2"
          >
          <img style={{height:'30px'}} src="../images/instagram.png"></img>
          </NavLink>

          <NavLink
            to="https://www.youtube.com/@huguetjulie610"
            target="_blank"
            className="text-black text-decoration-none me-2"
          >
          <img style={{height:'30px'}} src="../images/youtube.png"></img>
          </NavLink>

          <NavLink
            to="https://www.facebook.com/juliehuguet.13"
            target="_blank"
            className="text-black text-decoration-none"
          >
          <img style={{height:'30px'}} src="../images/facebook.png"></img>
          </NavLink>
        </div>

                <hr className="my-3" />

        {/* 🔹 Navigation à gauche / Copyright à droite */}
        <div className="d-flex justify-content-between align-items-center flex-wrap pb-4 small">

          {/* Navigation (collée à gauche du container) */}
          <div>
            <NavLink to="/" style={{fontFamily:'pangram-sans-medium'}} className="text-black text-decoration-none me-4">
              {t("nav_home")}
            </NavLink>

            <NavLink to="/legal-notices" style={{fontFamily:'pangram-sans-medium'}} className="text-black text-decoration-none me-4">
              {t("nav_legal_notices")}
            </NavLink>

            <NavLink to="/privacy_policy" style={{fontFamily:'pangram-sans-medium'}} className="text-black text-decoration-none">
              {t("nav_privacy_policy")}
            </NavLink>
          </div>

          {/* Copyright (collé à droite) */}
          <div className="mt-3 mt-md-0">
            © {new Date().getFullYear()} •{" "}
            <NavLink
              to="https://www.gailogailo.com"
              target="_blank"
              className="text-black text-decoration-underline"
            >
              <b>GAÏLO GAÏLO</b>
            </NavLink>{" "}
            x{" "}
            <NavLink
              to="https://www.facioproductions.fr"
              target="_blank"
              className="text-black text-decoration-underline"
            >
              <b>Facio Productions</b>
            </NavLink>{" "}
            — {t("allrightsreserved")}
          </div>

        </div>

      </div>
    </footer>
  );
}